
// import toast from "react-hot-toast";
import {
  FETCH_LEAVE_TYPES_REQUEST,
  FETCH_LEAVE_TYPES_SUCCESS,
  FETCH_LEAVE_TYPES_FAILURE,
  CREATE_LEAVE_TYPE_REQUEST,
  CREATE_LEAVE_TYPE_SUCCESS,
  CREATE_LEAVE_TYPE_FAILURE,
  FETCH_LEAVE_TYPES_MASTER_REQUEST,
  FETCH_LEAVE_TYPES_MASTER_SUCCESS,
  FETCH_LEAVE_TYPES_MASTER_FAILURE,
  CREATE_LEAVE_TYPE_MASTER_REQUEST,
  CREATE_LEAVE_TYPE_MASTER_SUCCESS,
  CREATE_LEAVE_TYPE_MASTER_FAILURE,
  UPDATE_LEAVE_TYPE_REQUEST,
  UPDATE_LEAVE_TYPE_SUCCESS,
  UPDATE_LEAVE_TYPE_FAILURE,
  // 👇 NEW ADMIN UPDATE TYPES
  UPDATE_LEAVE_TYPE_ADMIN_REQUEST,
  UPDATE_LEAVE_TYPE_ADMIN_SUCCESS,
  UPDATE_LEAVE_TYPE_ADMIN_FAILURE,
} from "../actions/leaveTypeActions";

const initialState = {
  leaveTypes: [],
  masterLeaveTypes: [],
  loading: false,
  error: null,
  creating: false,
  createError: null,
};

const leaveTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH LEAVE TYPES (Regular)
    case FETCH_LEAVE_TYPES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LEAVE_TYPES_SUCCESS:
      return { ...state, loading: false, leaveTypes: action.payload };

    case FETCH_LEAVE_TYPES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // CREATE LEAVE TYPE (Regular)
    case CREATE_LEAVE_TYPE_REQUEST:
      return { ...state, creating: true, createError: null };

    case CREATE_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        creating: false,
        leaveTypes: [...state.leaveTypes, action.payload.data],
      };

    case CREATE_LEAVE_TYPE_FAILURE:
      return { ...state, creating: false, createError: action.payload };

    // UPDATE LEAVE TYPE (Regular)
    case UPDATE_LEAVE_TYPE_REQUEST:
      return { ...state, creating: true, createError: null };

    case UPDATE_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        creating: false,
        leaveTypes: state.leaveTypes.map((type) =>
          type.id === action.payload.data.id ? action.payload.data : type
        ),
      };

    case UPDATE_LEAVE_TYPE_FAILURE:
      return { ...state, creating: false, createError: action.payload };

    // ✅ UPDATE LEAVE TYPE (Admin)
    case UPDATE_LEAVE_TYPE_ADMIN_REQUEST:
      return { ...state, creating: true, createError: null };

    case UPDATE_LEAVE_TYPE_ADMIN_SUCCESS:
      return {
        ...state,
        creating: false,
        leaveTypes: state.leaveTypes.map((type) =>
          type.id === action.payload.data.id ? action.payload.data : type
        ),
      };

    case UPDATE_LEAVE_TYPE_ADMIN_FAILURE:
      return { ...state, creating: false, createError: action.payload };

    // FETCH MASTER LEAVE TYPES
    case FETCH_LEAVE_TYPES_MASTER_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LEAVE_TYPES_MASTER_SUCCESS:
      return { ...state, loading: false, masterLeaveTypes: action.payload };

    case FETCH_LEAVE_TYPES_MASTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // CREATE MASTER LEAVE TYPE
    case CREATE_LEAVE_TYPE_MASTER_REQUEST:
      return { ...state, creating: true, createError: null };

    case CREATE_LEAVE_TYPE_MASTER_SUCCESS:
      return {
        ...state,
        creating: false,
        masterLeaveTypes: [...state.masterLeaveTypes, action.payload.data],
      };

    case CREATE_LEAVE_TYPE_MASTER_FAILURE:
      return { ...state, creating: false, createError: action.payload };

    default:
      return state;
  }
};

export default leaveTypeReducer;
